<template>
  <div
    :class="{
      'multiple-select_active': active,
      'multiple-select-view-wrap': true,
    }"
    @click="showPicker"
  >
    <span v-if="value && value.length" class="multiple-select-text">{{ valueShow }}</span>
    <span v-else class="multiple-select-placeholder">{{ _placeholder }}</span>
    <Popup
      v-model="visible"
      class="multiple-popup"
      :ratio="55"
      :title="title"
      :confirm-txt="`${$t('Gattaran_form_zKmF_tGJc' /** 确认 */)}(${
        (tempValue && tempValue.length) || 0
      })`"
      @cancel="cancel"
      @confirm="confirm"
    >
      <div class="multiple-popup-content">
        <CheckboxGroupView v-model="tempValue" :options="options" />
      </div>
    </Popup>
  </div>
</template>

<script>
import Popup from '../Popup'
import CheckboxGroupView from '../Checkbox/CheckboxGroupView.vue'

export default {
  components: { Popup, CheckboxGroupView },
  /* eslint-disable */
  props: {
    options: {
      default: () => [],
    },
    placeholder: {},
    value: {
      default: () => [],
    },
    title: {},
    disabled: {
      default: false,
    },
  },
  /* eslint-enable */
  data() {
    return {
      visible: false,
      active: false,
      tempValue: [],
    }
  },
  computed: {
    _placeholder() {
      return this.placeholder || ''
    },
    valueShow() {
      const { value = [] } = this
      const labels =
        value.map(item => {
          const temp = this.options.find(el => el.value === item) || {}
          return temp.label || temp.value
        }) || []
      return labels.join(',')
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.tempValue = newVal
        }
      },
    },
  },
  methods: {
    showPicker() {
      if (this.disabled) {
        return
      }
      this.visible = true
      this.active = true
    },
    cancel() {
      this.visible = false
      this.active = false
      this.tempValue = this.value
    },
    confirm() {
      this.$emit('input', [...this.tempValue])
      this.$emit('change', [...this.tempValue])
      this.active = false
      return true
    },
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
